import { render } from "./DesktopFilesComponent.vue?vue&type=template&id=169726f9&scoped=true"
import script from "./DesktopFilesComponent.vue?vue&type=script&lang=js"
export * from "./DesktopFilesComponent.vue?vue&type=script&lang=js"

import "./DesktopFilesComponent.vue?vue&type=style&index=0&id=169726f9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169726f9"]])

export default __exports__